<template>
  <div v-if="links && links.length > 0">
    <slot name="title"></slot>

    <div class="mt-16 flex flex-wrap gap-8 overflow-x-auto">
      <RevButton
        v-for="link in links"
        :key="link.title"
        data-selector="product-tag"
        size="small"
        :to="link.relativeLink"
        variant="primary"
        @click="handleLinkClick(link.relativeLink, $event)"
      >
        {{ link.title }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from '#imports'
import { nextTick } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'

import type { LinkBooster } from '~~/shared/api/internal-links/types'

const route = useRoute()
const router = useRouter()
const { trackClick } = useTracking()

defineProps<{
  links: LinkBooster[]
}>()

function handleLinkClick(target: string, event: MouseEvent | KeyboardEvent) {
  trackClick({ zone: 'tags', name: `product-tag-${target}` })

  if (
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    router.resolve(target).path !== route.path
  )
    return

  nextTick(() => window.scrollTo(0, 0))
}
</script>
